import type { ReactNode } from 'react';
import { cn } from '../../lib/cn';

export function Pill({ children, tone = 'terracotta', className }: { children: ReactNode; tone?: 'terracotta' | 'ink'; className?: string }) {
  const tones = {
    terracotta: 'bg-l-terracotta-soft text-l-marginalia',
    ink: 'bg-l-paper-soft text-l-ink-muted border border-l-rule/60',
  } as const;
  return (
    <span className={cn(
      'inline-flex items-center h-6 px-2.5 rounded-full font-sans text-[11px] font-semibold uppercase tracking-[0.08em]',
      tones[tone],
      className,
    )}>
      {children}
    </span>
  );
}
